// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 461 ? "webfontloader" : chunkId) + "." + {"96":"0fdf3472","461":"4a74ae21","976":"9ebdaba7","992":"161b6ccd"}[chunkId] + ".js";
};